const isDev = import.meta.env.DEV;
const prodBaseUrl =
    import.meta.env.VITE_API_BASE_URL ||
    "https://peerfectit-backend.nullbox.cn/api";

export const baseUrl = isDev
    ? "http://localhost:8000/api"
    : prodBaseUrl;
